
import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';

import List from './list';




class Post extends Component {
    render() {
        return (
            <Switch>
                {/* <Route
                    path="/contact/create"
                    render={props => <Create type='create' {...props} />}
                />
                <Route
                    path="/contact/update/:slug"
                    render={props => <Create type='update' {...props} />}
                /> */}
                <Route
                    path="/contact/list"
                    render={props => <List {...props} />}
                />
            </Switch>
        );
    }
}


export default Post